import { createSelector } from '@reduxjs/toolkit'
import type { Authentication, FingerPrint, FingerprintHeader } from '../../../model'
import type { AuthenticationState } from './reducer'
import { ConsumerAppSelector } from '../../store'

export const authenticationStateSelector: ConsumerAppSelector<AuthenticationState> = (state) => state.auth.user

export const authenticationSelector: ConsumerAppSelector<Authentication> = createSelector(authenticationStateSelector, (state) => state.status)

// @ts-ignore: OPERATION BLEED STOPPER
export const fingerprintSelector: ConsumerAppSelector<FingerPrint> = createSelector(authenticationStateSelector, (state) => state.fingerprint)

// @ts-ignore: OPERATION BLEED STOPPER
export const fingerprintHeader: ConsumerAppSelector<FingerprintHeader> = createSelector(fingerprintSelector, (fingerprint) => ({
  'X-Device-Fingerprint': JSON.stringify(fingerprint),
}))

export const fingerprintHeaderValue: ConsumerAppSelector<string | undefined> = createSelector(fingerprintSelector, (fingerprint) =>
  fingerprint !== null ? JSON.stringify(fingerprint) : undefined
)

// @ts-ignore: OPERATION BLEED STOPPER
export const profilingIdSelector: ConsumerAppSelector<string> = createSelector(authenticationStateSelector, (state) => state?.profilingId)

export const shouldAllowEmailSelector: ConsumerAppSelector<boolean | undefined> = createSelector(
  authenticationStateSelector,
  (state) => state?.shouldAllowEmail
)
